const focusOutline = (e) => {
    if (e.which === 9) {
        document.documentElement.classList.remove('no-focus-outline');
    }
}

const events = () => {
    document.body.addEventListener('keyup', focusOutline);
}

const init = () => {
  events();
}

export default init;